import { UserSettings } from '@miq/utils';

enum SpecialEditableFieldIds {
  Price = 196,
  AskingDirectRate = 185,
  AskingSubLeaseRate = 186,
}

const FILEDS_MONTHLY_ARGS_IDS = {
  [SpecialEditableFieldIds.Price]: [206, 16355, 16357],
  [SpecialEditableFieldIds.AskingDirectRate]: [1083, 1085, 3720],
  [SpecialEditableFieldIds.AskingSubLeaseRate]: [16363, 16365, 16371],
};
const FILEDS_YEARLY_ARGS_IDS = {
  [SpecialEditableFieldIds.Price]: [206, 16359, 16361],
  [SpecialEditableFieldIds.AskingDirectRate]: [1087, 1089, 3720],
  [SpecialEditableFieldIds.AskingSubLeaseRate]: [16367, 16369, 16371],
};

export function specialEditableFieldsArgs() {
  return UserSettings.isYearlyPreference() ? FILEDS_YEARLY_ARGS_IDS : FILEDS_MONTHLY_ARGS_IDS;
}
